import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import {
    updateZeroDollarModalVisibility,
} from "../../../actions/menu";

@connect(mapStateToProps)
export default class ConfirmZeroDollarModal extends Component {
    constructor(props) {
        super(props);
    }

    getConfirmDialog = () => {
        const {
            ConfirmZeroDollarBookingTitle,
            ConfirmZeroDollarBooking,
            ConfirmZeroDollarBookingConfirm,
            ConfirmZeroDollarBookingCancel
        } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

        let handleConfirm = () => {
            this.props.dispatch(updateZeroDollarModalVisibility(false))
            this.props.onConfirm();
        }

        let handleCancel = () => {
            this.props.dispatch(updateZeroDollarModalVisibility(false))
        }

        return <div className="save-box">
            <section className="header">
                <button type="button" className="close_button" onClick={handleCancel}>

                </button>
                <p className="title">{ConfirmZeroDollarBookingTitle}</p>
                <p className="body_text">{ConfirmZeroDollarBooking}</p>
            </section>
            <div className="save_box_buttons">
                <button type="button" className="ui button cancel_btn" onClick={handleCancel}>
                    {ConfirmZeroDollarBookingCancel}
                </button>
                <button type="button" className="ui button send_btn" onClick={handleConfirm}>
                    {ConfirmZeroDollarBookingConfirm}
                </button>
            </div>
        </div>
    }

    getConfirmZeroDollarModal = () => {
        if (!this.props.zeroDollarModalVisible) {
            return "";
        }

        return <Modal className="bookingdetails-model discard-changes-modal 
                                transparent-bg no-borders" open={true}>
            <Modal.Content className="modal_popup transparent-bg">
                <div className="modal_overlay"></div>
                {this.getConfirmDialog()}
            </Modal.Content>
        </Modal>
    }

    render() {
        return this.getConfirmZeroDollarModal();
    }
}
function mapStateToProps(state) {
    return {
      zeroDollarModalVisible : state.menuReducer.zeroDollarModalVisible,
      invoiceData: state.appointmentCheckoutReducer.invoiceData
    };
}